// Advisor Constants
import {
  STATUS_HOLD,
  STATUS_NOT_SCHEDULUED,
  STATUS_APPROVAL,
  STATUS_ACCEPTED,
  STATUS_WAITING_FOR_APPROVAL,
  STATUS_ACTIVE,
  STATUS_UN_HOLD,
  STATUS_DECLINED, STATUS_RENEWED
} from 'src/services/constants';
import SiteSettings from 'src/siteSetting';
import {
  toLower,
  pathOr,
  always,
  T,
  cond,
  equals,
  toUpper,
  head,
  filter,
} from 'ramda';

export const DESIGNATIONS_OPTIONS = [
  { option: 'Select', value: 'select' },
  { option: 'MLO', value: 'mlo' },
  { option: 'Senior MLO', value: 'senior_mlo' },
  { option: 'Broker', value: 'broker' },
];



export const MONTHLY_INTERVAL_PERIOD = 'Monthly';
export const DOWNCASE_MONTHLY_INTERVAL_PERIOD = toLower(
  MONTHLY_INTERVAL_PERIOD
);
export const WEEKLY_INTERVAL_PERIOD = 'Weekly';
export const DOWNCASE_WEEKLY_INTERVAL_PERIOD = toLower(WEEKLY_INTERVAL_PERIOD);
export const SEMIMONTHLY_INTERVAL_PERIOD = 'Semi-monthly';
export const JOIN_SEMIMONTHLY_INTERVAL_PERIOD_NAME = 'semimonthly';
export const DAILY_INTERVAL_PERIOD_NAME = 'Daily';
export const DOWNCASE_DAILY_INTERVAL_PERIOD = toLower(
  DAILY_INTERVAL_PERIOD_NAME
);

export const ACH_PAYMENT_METHOD = 'ACH';
export const ACH_PAYMENT_METHOD_VALUE = 'ach';
export const FEE_WIRE_PAYMENT_METHOD = 'WIRE';
export const FEE_WIRE_PAYMENT_METHOD_VALUE = 'Wire';

export const STACKING_FEE = 'Stacking Fee';
export const UPPERCASE_STACKING_FEE = toUpper(STACKING_FEE);
export const FEE_BALANCE = 'Fee balance';
export const UPPERCASE_FEE_BALANCE = toUpper(FEE_BALANCE);
export const RETURNED_PAYMENT_FEE = 'Returned Payment Fee';
export const UPPERCASE_RETURNED_PAYMENT_FEE = toUpper(RETURNED_PAYMENT_FEE);
export const LATE_PAYMENT_FEE = 'Late Payment Fee';
export const UPPERCASE_LATE_PAYMENT_FEE = toUpper(LATE_PAYMENT_FEE);
export const ACCOUNT_BLOCKED_FEE =
  'Blocked/Frozen Account/Stopped Payment Fee ';
export const UPPERCASE_ACCOUNT_BLOCKED_FEE = toUpper('Blocked account fee');
export const UCC_FILLING_FEE = 'UCC Filing Fee';
export const UPPERCASE_UCC_FILLING_FEE = toUpper(UCC_FILLING_FEE);
export const COLLECTION_FEE = 'Collection Fee ';
export const UPPERCASE_COLLECTION_FEE = toUpper(COLLECTION_FEE);
export const LEGAL_FEE = 'Legal Fee';
export const UPPERCASE_LEGAL_FEE = toUpper(LEGAL_FEE);
export const FEE_WAVIER = 'Fee Wavier';
export const UPPERCASE_FEE_WAVIER = toUpper(FEE_WAVIER);
export const PAYMENT = 'Payment';
export const UPPERCASE_PAYMENT = toUpper(PAYMENT);
export const ORGINATION_FEE = 'Origination Fee';
export const UPPERCASE_ORGINATION_FEE = toUpper(ORGINATION_FEE);
export const UPPERCASE_FUNDING_PAYMENT_TYPE = 'FUNDING';
export const WAIVED_PAYMENT_TYPE = 'waived';
export const UPPERCASE_WAIVED_PAYMENT_TYPE = toUpper(WAIVED_PAYMENT_TYPE);

export const SCHEDULED = 'Scheduled';
export const COLLECTING = 'Collecting';
export const NOT_COLLECTED = 'Not Collected';
export const COLLECTED = 'Settled';
export const HOLD = 'Hold';
export const HOLD_SUBTITLE =
  'This loan is put on hold. Any further payments after the hold dated will not be scheduled.';
export const COLLECTION_ERROR = 'Collection Error';
export const PAY_OFF = 'Pay off';
export const PAY_OFF_SUBTITLE =
  'The loan can be paid off. Any existing payment schedule after the paid off date are put on hold.';
export const WRITE_OFF = 'Write off';
export const WRITE_OFF_SUBTITLE =
  'This loan is written off. All the further payments after today will not be scheduled.';

export const EDIT = 'EDIT';
export const SAVE = 'SAVE';
export const SCHEDULE_PATH = ['schedule'];
export const GRP_PERMISSION = 'support';
export const DISABLE_COUNT_AND_ACTION_FOR_PAYMENT_TYPE = [
  UPPERCASE_ORGINATION_FEE,
  UPPERCASE_FUNDING_PAYMENT_TYPE,
];

export const INTERVAL_SCHEDULE = [
  { name: MONTHLY_INTERVAL_PERIOD, value: DOWNCASE_MONTHLY_INTERVAL_PERIOD },
  { name: WEEKLY_INTERVAL_PERIOD, value: DOWNCASE_WEEKLY_INTERVAL_PERIOD },
  {
    name: SEMIMONTHLY_INTERVAL_PERIOD,
    value: JOIN_SEMIMONTHLY_INTERVAL_PERIOD_NAME,
  },
  {
    name: DAILY_INTERVAL_PERIOD_NAME,
    value: DOWNCASE_DAILY_INTERVAL_PERIOD,
  },
];

export const PAYMENT_METHOD = [
  {
    name: ACH_PAYMENT_METHOD,
    value: ACH_PAYMENT_METHOD_VALUE,
  },
  {
    name: FEE_WIRE_PAYMENT_METHOD,
    value: FEE_WIRE_PAYMENT_METHOD_VALUE,
  },
];

export const getShowNameForPaymentMethod = (paymentMethod: any) => {
  return head(
    filter(
      (_paymentMethod: any) =>
        equals(pathOr('', ['value'], _paymentMethod), paymentMethod),
      PAYMENT_METHOD
    )
  );
};

export const TYPES_OF_FEES = [
  { name: STACKING_FEE, value: UPPERCASE_STACKING_FEE },
  { name: RETURNED_PAYMENT_FEE, value: UPPERCASE_RETURNED_PAYMENT_FEE },
  { name: LATE_PAYMENT_FEE, value: UPPERCASE_LATE_PAYMENT_FEE },
  { name: ACCOUNT_BLOCKED_FEE, value: UPPERCASE_ACCOUNT_BLOCKED_FEE },
  { name: UCC_FILLING_FEE, value: UPPERCASE_UCC_FILLING_FEE },
  { name: COLLECTION_FEE, value: UPPERCASE_COLLECTION_FEE },
  { name: LEGAL_FEE, value: UPPERCASE_LEGAL_FEE },
  { name: FEE_BALANCE, value: UPPERCASE_FEE_BALANCE },
  { name: FEE_WAVIER, value: UPPERCASE_FEE_WAVIER },
];

export const FEES_LIST = [
  UPPERCASE_STACKING_FEE,
  UPPERCASE_RETURNED_PAYMENT_FEE,
  UPPERCASE_LATE_PAYMENT_FEE,
  UPPERCASE_ACCOUNT_BLOCKED_FEE,
  UPPERCASE_UCC_FILLING_FEE,
  UPPERCASE_COLLECTION_FEE,
  UPPERCASE_LEGAL_FEE,
  UPPERCASE_FEE_WAVIER,
  UPPERCASE_FEE_BALANCE,
];
export const FEE_WAVIER_LIST = [UPPERCASE_FEE_WAVIER];

export const COMMON_FACTOR_RATE = 1.35;
/* The number of columns to display in a row while displaying the access control checklist
 **/
export const DISPLAY_NUMBER_OF_COLUMNS_IN_A_ROW_FOR_ACCESS_COMTROL_CHECKLIST = 2;

/* The total number of columns available for display for acces control checklist
 **/
export const TOTAL_NUMBER_OF_COLUMNS_IN_A_ROW_FOR_ACCESS_COMTROL_CHECKLIST = 12;

export const getStatus = (schedule: any) => {
  const paymentStatus = pathOr('', ['paymentStatus'], schedule);
  const { status, className, settled_at } = _mkScheduleStatus(paymentStatus);
  return {
    status,
    settled_at,
    className,
  };
};

const _getDisplayStatus = (tableKind: string) => {
  switch (String(tableKind)) {
    case `payment_paid`:
      return COLLECTED
    case 'payment_unpaid':
      return COLLECTION_ERROR
    case 'payment_not_collected':
      return NOT_COLLECTED
    case 'payment_hold':
      return HOLD
    case 'payment_request':
      return COLLECTING
    case 'payment_not_scheduled':
      return STATUS_NOT_SCHEDULUED
    case 'payments_write_off':
      return STATUS_NOT_SCHEDULUED
    case 'payment_approval':
      return STATUS_WAITING_FOR_APPROVAL
    case 'payment_approved':
      return STATUS_ACCEPTED
    case 'payment_declined':
      return STATUS_DECLINED;
    case 'payment_renew':
      return STATUS_RENEWED;
    default:
      return SCHEDULED;
  }
}

const _mkScheduleStatus = (paymentStatus: any) => {
  const tableKind = String(pathOr('', ['table_kind'], paymentStatus));
  const settled_at = pathOr('', ['metadata', 'lendsmart_sh/achworks_action_date'], paymentStatus) || pathOr('', ['created_at'], paymentStatus)
  const status = _getDisplayStatus(tableKind)
  return {
    status: status,
    settled_at: equals(COLLECTED, status) ? settled_at : '',
    className: _mkScheduleClassName(status),
  };
};

const _mkScheduleClassName = (status: any) => {
  switch (status) {
    case COLLECTED:
      return 'status-success';
    case COLLECTION_ERROR:
      return 'status-error';
    case NOT_COLLECTED:
      return 'status-not-collected';
    case HOLD:
      return 'status-hold';
    case 'payment_request':
      return 'status-collecting';
    case 'payment_not_scheduled':
      return 'status-hold';
    case 'payments_write_off':
      return 'status-hold';
    case 'payment_approval':
      return 'status-hold';
    case 'payment_approved':
      return 'status-success';
    case 'payment_declined':
      return 'status-error';
    case COLLECTING:
      return 'status-collecting';
    case STATUS_WAITING_FOR_APPROVAL:
      return 'status-awaiting';

    default:
      return 'status-scheduled';
  }
};

export const getPaymentSchedulesStatus = (status: any) => {
  return cond([
    [
      equals(STATUS_HOLD),
      always({
        table_kind: 'payment_hold',
      }),
    ],
    [
      equals(NOT_COLLECTED),
      always({
        table_kind: 'payment_not_collected',
      }),
    ],
    [
      equals(STATUS_NOT_SCHEDULUED),
      always({
        table_kind: 'payment_not_scheduled',
      }),
    ],
    [
      equals(WRITE_OFF),
      always({
        table_kind: 'payments_write_off',
      }),
    ],
    [
      equals(STATUS_APPROVAL),
      always({
        table_kind: 'payment_approval',
      }),
    ],
    [
      equals(STATUS_ACCEPTED),
      always({
        table_kind: 'payment_approved',
      }),
    ],
    [
      equals(STATUS_DECLINED),
      always({
        table_kind: 'payment_declined',
      }),
    ],
    [
      equals(STATUS_RENEWED),
      always({
        table_kind: 'payment_renew',
      }),
    ],
  ])(status);
};

export const SERVICING_LOAN_ACTIONS = [
  { displayName: HOLD, value: HOLD, subTitle: HOLD_SUBTITLE },
  { displayName: PAY_OFF, value: PAY_OFF, subTitle: PAY_OFF_SUBTITLE },
  { displayName: WRITE_OFF, value: WRITE_OFF, subTitle: WRITE_OFF_SUBTITLE },
];

export const SERVICING_LOAN_ACTIONS_UN_HOLD = [
  { displayName: STATUS_UN_HOLD, value: STATUS_ACTIVE },
  { displayName: PAY_OFF, value: PAY_OFF, subTitle: PAY_OFF_SUBTITLE },
  { displayName: WRITE_OFF, value: WRITE_OFF, subTitle: WRITE_OFF_SUBTITLE },
];
export const getServicingLoanActionBasedOnStatus = (status: any) => {
  return cond([
    [equals(STATUS_HOLD), always(SERVICING_LOAN_ACTIONS_UN_HOLD)],
    [equals(STATUS_ACTIVE), always(SERVICING_LOAN_ACTIONS)],
    [T, always(SERVICING_LOAN_ACTIONS)],
  ])(status);
};

const APPLICATIONS = 'Applications'
const QUEUE = 'Queue';
export const wordMyLoansAs = 'My ' + APPLICATIONS;
export const wordMyAppsUpper = wordMyLoansAs
export const wordAllLoans = SiteSettings.pipeLineNameForAllApps();
export const wordDpLoanAs = `Ca ${QUEUE}`;
export const wordUwLoanAs = `Uw ${QUEUE}`;
export const wordCDPLoanAs = `CDP ${QUEUE}`;
export const wordPrequalifLoanAs = `Prequalified ${QUEUE}`;
export const wordCentralGroup = `Central Group`;

export const OPTIONS_FOR_PRIORITY = [
  {
    label: 'All', value: '',
  },
  {
    label: 'Priority', value: 'High',
    "flag_color": "#CA0813"
  },
];
